import { ROLE_TYPE } from './types';
import useRequireRoles from './useRequireRoles';
import useRoles from './useRoles';

export const useIsSuper = () => useRoles(ROLE_TYPE.SUPER);
export const useRequireSuper = () => useRequireRoles(ROLE_TYPE.SUPER);
